import {BackendBillingData, BillingData} from '@/types/billing-data';

export const sanitizeBillingData = (backendData: {
  billingData: BackendBillingData;
}): BillingData => {
  const data = backendData.billingData;

  return {
    name: data.name || '',
    email: data.email || '',
    address: {
      street: data.street || '',
      streetNumber: data.streetNumber || '',
      postalCode: data.postalCode || '',
      city: data.city || '',
      country: data.country || '',
      fullAddress:
        data.street || data.city || data.country
          ? `${data.street || ''} ${data.streetNumber || ''}, ${
              data.postalCode || ''
            } ${data.city || ''}, ${data.country || ''}`
          : ''
    },
    subscription: data.subscription || null
  };
};
